import { useTranslation } from "@fmc-digital/i18n";
import { cn } from "@fmc-digital/ui";
import {
  registrationFeedbackSurveyBannerStyles,
  registrationFeedbackSurveyBannerTextStyles,
} from "./registration-feedback-survey-banner.styles";

export function RegistrationFeedbackSurveyBanner() {
  const { t } = useTranslation();

  return (
    <div
      className={cn(registrationFeedbackSurveyBannerStyles())}
      data-testid="registration-feedback-survey-banner"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        className="shrink-0 lg:mt-0.5"
      >
        <circle cx="12" cy="12" r="10" fill="#003049" />
        <path
          d="M12 7.5C11.4477 7.5 11 7.94772 11 8.5C11 9.05228 11.4477 9.5 12 9.5C12.5523 9.5 13 9.05228 13 8.5C13 7.94772 12.5523 7.5 12 7.5Z"
          fill="white"
        />
        <path
          d="M11 11.5C11 11.2239 11.2239 11 11.5 11H12.5C12.7761 11 13 11.2239 13 11.5V16.5C13 16.7761 12.7761 17 12.5 17H11.5C11.2239 17 11 16.7761 11 16.5V11.5Z"
          fill="white"
        />
      </svg>
      <p className={cn(registrationFeedbackSurveyBannerTextStyles())}>
        {t("auth.registration.feedback.nps.surveyBanner")}
      </p>
    </div>
  );
}
